import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Typography,
  Divider,
  Icon,
  Input,
  Button,
} from 'antd';

import moment from 'moment';
import {
  formatCell,
  sorter,
  createColumns,
} from '../../../helpers';

import { Filters } from '../../../containers/Filters';
import DataTable from '../../../containers/DataTable';
import Panes from '../../Panes';
import Graph from '../../Graph';
import StatsCards from '../../StatsCards';
import {
  Spinner,
  TooltippedLink,
} from '../../UI';

const { Title } = Typography;

class Overview extends PureComponent {
  state = {
    filters: {
      aff: '',
      dt: '',
      count: 10,
      timeZone: '',
    },
    searchText: '',
    typeOfStatistics: 'ver',
    tabKey: 'money',
    today: moment(new Date()).format('YYYY-MM-DD'),
  };

  componentDidMount () {
    this.props.fetchUserInfo(() => {
      const payload = {
        aff: '',
        dt: this.state.today,
        count: this.state.filters.count,
        timeZone: this.props.user.time_zone,
        typeOfStatistics: this.state.typeOfStatistics
      };

      this.setState((state) => {
        return {
          filters: {
            ...state.filters,
            aff: payload.aff,
            count: payload.count,
            dt: payload.dt,
            timeZone: payload.timeZone,
          }
        };
      });

      this.handleChangeFilter(payload);
    });
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{padding: 8}}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder="Search in column"
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{
            width: 188,
            marginBottom: 8,
            display: 'block'
          }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{width: 90, marginRight: 8}}
        >
          Search
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{width: 90}}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      return record[dataIndex].toString().toLowerCase().indexOf(value.toString()) > -1;
    },
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    }
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  handleChange = (date, dateString) => {
    this.setState((state) => {
      return {
        filters: {
          ...state.filters,
          dt: dateString,
        }
      };
    });

    const payload = {
      ...this.state.filters,
      dt: dateString,
    };

    this.handleChangeFilter(payload);
  };

  handleSelect = (value) => {
    this.setState((state) => {
      return {
        filters: {
          ...state.filters,
          aff: value,
        }
      };
    });

    const payload = {
      ...this.state.filters,
      aff: value,
    };

    this.handleChangeFilter(payload);
  };

  handleType = (label) => {
    this.setState(() => {
      const typeOfStatistics = label;

      return {
        typeOfStatistics
      };
    });

    this.props.setFilter({
      ...this.props.filters,
      typeOfStatistics: label,
    });
  };

  handleTab = (tabKey) => {
    const payload = {
      ...this.state.filters
    };

    this.props.fetchDashGraph(payload);

    this.setState({
      tabKey
    });

    this.props.setFilter({
      ...this.props.filters,
      ...payload,
      tabKey,
    });
  };

  handleChangeFilter = (payload) => {
    this.props.setFilter({
      ...this.props.filters,
      ...payload,
      typeOfStatistics: this.state.typeOfStatistics
    });
    this.props.fetchDashGraph(payload);
    this.props.fetchDashTop(payload);
    this.props.fetchDashStats(payload);
  };

  handleSub = (value) => {
    this.setState((state) => {
      return {
        filters: {
          ...state.filters,
          count: value,
        }
      };
    });

    const payload = {
      ...this.state.filters,
      count: value,
    };

    this.props.fetchDashTop(payload);
  };

  update = () => {
    this.props.fetchDashTop(this.state.filters);
  };

  render() {
    const {
      loading,
      pageLoading,
      graphLoading,
      statsLoading,
      graph,
      subs,
      stats,
      subs: { tableName }
    } = this.props;
    const { typeOfStatistics } = this.state;
    const statistic = stats.length > 0 && stats[0];
    const fieldsObj = subs.fields && subs.fields[0];

    const renderTableCell = (text, record, item) => {
      const { aff, saff, } = record;

      if (item.html) {
        if (item.html.id === 'ErrClicksStats') {
          const to = `/reports/filtered_clicks?dt1=${this.state.filters.dt}&dt2=${this.state.filters.dt}&aff=${aff ? aff : ''}&saff=${saff ? saff : ''}`;

          return item.html.tooltip ? (
            <TooltippedLink
              title={item.html.tooltip}
              link={formatCell(item, text)}
              to={to}
            />
          ) : (
            <Link to={to}>{formatCell(item, text)}</Link>
          );
        }

        if (item.html.id === 'SubIDStats') {
          const to = `/reports/subID?dt1=${this.state.filters.dt}&dt2=${this.state.filters.dt}&aff=${aff}`;

          return item.html.tooltip ? (
            <TooltippedLink
              title={item.html.tooltip}
              link={formatCell(item, text)}
              to={to}
            />
          ) : (
            <Link to={to}>{formatCell(item, text)}</Link>
          );
        }
      }

      return formatCell(item, text);
    };

    const columns = createColumns(
      fieldsObj,
      sorter,
      renderTableCell,
      this.getColumnSearchProps,
    );

    const isVerified = typeOfStatistics  === 'ver';
    const moneyDataKeys = isVerified ? { yesterday: 'pVerAmount', today: 'tVerAmount' } : { yesterday: 'pEstAmount', today: 'tEstAmount' };
    const clicksDataKeys = isVerified ? { yesterday: 'pVerClicks', today: 'tVerClicks' } : { yesterday: 'pEstClicks', today: 'tEstClicks' };
    const requestsDataKeys = isVerified ? { yesterday: 'pOkRequests', today: 'tOkRequests' } : { yesterday: 'pRequests', today: 'tRequests' };
    const graphOptions = [
      {
        tab: <span><Icon type="dollar" />Money</span>,
        key: 'money',
        child: <Graph
          data={graph}
          bars={[
            { fill: '#2196f3', dataKey: moneyDataKeys.yesterday, name: 'Yesterday' },
            { fill: '#ff9800', dataKey: moneyDataKeys.today, name: 'Today' },
          ]}
          XAxisDataKey='hour'
        />
      },
      {
        tab: <span><Icon type="control" />Clicks</span>,
        key: 'clicks',
        child: <Graph
          data={graph}
          bars={[
            { fill: '#2196f3', dataKey: clicksDataKeys.yesterday, name: 'Yesterday' },
            { fill: '#ff9800', dataKey: clicksDataKeys.today, name: 'Today' },
          ]}
          XAxisDataKey='hour'
        />
      },
      {
        tab: <span><Icon type="project"/>Requests</span>,
        key: 'requests',
        child: <Graph
          data={graph}
          bars={[
            {fill: '#2196f3', dataKey: requestsDataKeys.yesterday, name: 'Yesterday'},
            {fill: '#ff9800', dataKey: requestsDataKeys.today, name: 'Today'},
          ]}
          XAxisDataKey='hour'
        />
      }
    ];

    let content = <Spinner />;
    if (!pageLoading) {
      content = (
        <>
          <Divider />
          <Filters
            defaultDate={moment()}
            handleChange={this.handleChange}
            handleSelect={this.handleSelect}
            handleType={this.handleType}
            subs={false}
          />
          {statsLoading ? <Spinner size="small" /> : <StatsCards statistic={statistic}/>}
          <Panes
            type="card"
            items={graphOptions}
            loading={graphLoading}
            handleTab={this.handleTab}
          />
          <Divider />
          <DataTable
            loading={loading}
            table={{
              columns: columns,
              data: subs,
              tableName: tableName,
              toolbar: {
                titleExport: 'Overview Export',
              }
            }}
            handleSub={this.handleSub}
            update={this.update}
          />
        </>
      );
    }

    return (
      <div>
        <Title>Overview</Title>
        {content}
      </div>
    );
  }
}

Overview.propTypes = {
  loading: PropTypes.bool.isRequired,
  pageLoading: PropTypes.bool.isRequired,
  graph: PropTypes.array.isRequired,
  subs: PropTypes.object.isRequired,
  stats: PropTypes.array.isRequired,
};

export default Overview;
